import { render, staticRenderFns } from "./article11.vue?vue&type=template&id=5ecd3cf6&scoped=true"
import script from "./article11.vue?vue&type=script&lang=js"
export * from "./article11.vue?vue&type=script&lang=js"
import style0 from "./article11.vue?vue&type=style&index=0&id=5ecd3cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecd3cf6",
  null
  
)

export default component.exports